<template>
    <v-card >
        <v-card-text>
            <v-row>
                <v-col cols="12" md="9">
                    <v-text-field 
                        v-model="search_field"
                        prepend-icon="search"
                        label="กรอกข้อมูลสมาชิกเพื่อค้นหา (เช่น ชื่อ, เบอร์โทร, อีเมล์, เลขบัตรประชาชน)" hint="">
                    </v-text-field>
                </v-col>
                <v-col cols="3" md="1" sm="2" class="flex"><v-btn color="primary" @click="search">ค้นหา</v-btn></v-col>
                <v-col v-if="createmember" cols="3" md="1" sm="2" class="flex"><v-btn color="primary" @click="()=>createmember()">เพิ่มสมาชิก</v-btn></v-col>
            </v-row>

                <v-data-table v-if="search_text != null"
                    :headers="headers"
                    :items="rows"
                    :items-per-page="5"
                    @click:row="onSelectMember"
                    class="elevation-1"
                >
                    <template v-slot:item.line_logo="{ item }">
                        <img :src="item.line_logo" width="48" class="pt-1"/>
                    </template>
                    <template v-slot:item.member_date="{ item }">
                        <div>{{ item.member_date.substring(0,10) + ' ' + item.member_date.substring(11,19) }}</div>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-btn class="ml-1"  tile color="primary" @click="onEditMember(item)"><v-icon>mdi-account-edit</v-icon></v-btn>
                        <v-btn class="ml-1" depressed color="primary" @click="onCreateAppointment(item)">{{ $t('add_appointment') }}</v-btn>
                    </template>
                </v-data-table>

        </v-card-text>


    </v-card>
</template>

<style>
table tr:hover {
    cursor: pointer;
}

</style>



<script>

import config from '@/../config.js'
import axios from 'axios';
import Staff from '@/model/instance/Staff.js'

export default {
    props: ['station_code','createmember','enableaction'],
    data: () => ({
        headers: [
            { text:'',value:'line_logo'},
            {text: 'LINE', value: 'line_name'},
            {text: 'member_form_1', value: 'member_form_1',width:"11%"},
            {text: 'member_form_2', value: 'member_form_2',width:"11%"},
            {text: 'member_form_3', value: 'member_form_3',width:"11%"},
            {text: 'member_form_4', value: 'member_form_4',width:"11%"},
            {text: 'member_form_5', value: 'member_form_5',width:"11%"},
            {text: 'เป็นสมาชิกเมื่อ', value: 'member_date'},
        ],
        rows: [],
        registerformlist : [],
        search_text : null,
        search_field : "",

        display_name_pos : -1
    }),
    computed: {
        is_search(){return this.search_text != null }
    },
    methods: {
        onEditMember(member){
            this.$emit('oneditmember',member);
        },
        onCreateAppointment(member){
            this.$emit('onCreateAppointment',member);
        },
        reset(){
            //this.search_text = null
        },
        onSelectMember(member) {
            this.$emit('onSelectMember',member);
        },
        search(){
            this.search_text = this.search_field
            var que = this.$store.commit('addLoading')
            axios.post(config.api.url.manage.member.search_memberlist_stationcode,{
                station_code : this.station_code
                ,fields : ["member_id","line_name","line_logo","member_form_1","member_form_2","member_form_3","member_form_4","member_form_5","member_date"]
                ,searchtext : this.search_field
                ,order : ""
                ,page : 1
            },{ headers: Staff.getTokenHeader()})
            .then(response => {
                this.rows = response.data.memberlist
                this.rows.forEach((r,i,arr)=>{
                    if(r['member_form_'+this.display_name_pos] != undefined)
                        arr[i]["display_name"] = this.display_name_pos > -1 ? r['member_form_'+this.display_name_pos].split(',').join(' ') : r["line_name"]
                    for(var j=1;j<=5;j++){
                        if(this.headers.some(i=>i.value=='member_form_'+j)){
                            if(arr[i]['member_form_'+j] != undefined && arr[i]['member_form_'+j].length > 0){
                                if(this.registerformlist[j-1].value_type_id==1){
                                    arr[i]['member_form_'+j] = arr[i]['member_form_'+j].split(',').join(' ')
                                }else if(this.registerformlist[j-1].value_type_id==2){
                                    arr[i]['member_form_'+j] = arr[i]['member_form_'+j].split(',')[1]
                                }
                            }
                        }
                    }
                    var d = new Date(r.member_date);
                    d.setHours(d.getHours()+7);
                    arr[i]['member_date'] = d.toISOString().substring(0,10) + ' ' + d.toISOString().substring(11,19);

                })

                this.$store.commit('finishLoading',que)
            })
        }
    },
    mounted : function () {
        if(this.enableaction){
            this.headers.push({text: '', value: 'action'})
        }
        var que = this.$store.commit('addLoading')
        axios.post(config.api.url.public.station.get_registerform,{station_code:this.station_code})
        .then(response => {

            this.registerformlist = response.data.registerformlist

            for(var j=5;j>0;j--){
                this.headers.forEach((v,i,arr)=>{
                    if(v.value=='member_form_'+j){
                        if(this.registerformlist.length>=j){
                            arr[i].text = this.$i18n.t('form_tag_'+this.registerformlist[j-1].form_tag)
                            if(this.registerformlist[j-1].form_tag=="name"){
                                this.display_name_pos = j
                            }
                        }else{
                            arr.splice(i, 1);
                        }
                    }
                })
            }
            
            this.$store.commit('finishLoading',que)
        })
        this.reset()
    } 
}
</script>